export const DAY_NAMES = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
export const DATE_FORMAT = "YYYY-MM-DD";

export const NEXT_MONTH = 1;
export const CURRENT_MONTH = 0;
export const PREV_MONTH = -1;
